<template>
    <a-select
        v-model="modelValue"
        :disabled="disabled"
        style="width: 200px"
        :placeholder="placeholder"
        @select="handleSelect"
        @search="handleSearch"
        @blur="handleBlur"
    >
        <a-select-option v-for="item in list" :key="item.id">
            {{ item.name }}
        </a-select-option>
    </a-select>
</template>

<script>
import { Select } from 'ant-design-vue'

import debounce from 'lodash/debounce'

import getMemberListService from '@service/teamManagement/getMemberListService'

export default {
    name: 'EnterpriseSelect',
    components: {
        ASelect: Select,
        ASelectOption: Select.Option
    },
    props: {
        value: {
            // type: String
            type: [Number, String]
        },
        fieldCode: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            list: []
        }
    },
    computed: {
        modelValue: {
            get() {
                return this.value
            },
            set(v) {
                console.log(v)
                this.$emit('input', v)
                this.$emit('blur')
            }
        }
    },
    created() {
        this.getList()
    },
    methods: {
        handleBlur() {
            this.$emit('blur')
        },
        async getList(name) {
            console.log(this.data, 'data')
            try {
                const params = {
                    projectCode: this.data.projectCode,
                    teamId: this.data.id
                }
                if (name) {
                    params.name = name
                }
                const list = await getMemberListService(params)
                console.log(list, 'list')
                this.$set(this, 'list', list)
                // this.list = list
            } catch (e) {
                console.log('-> e', e)
            }
        },
        handleSearch: debounce(function (name) {
            console.log(name)
            this.getList(name)
        }, 500),
        handleSelect(val) {
            this.$emit('change', val)
        }
    }
}
</script>

<style lang="scss"></style>
